// extracted by mini-css-extract-plugin
export default {"image":"SimpleMap_image__vKLRK","container":"SimpleMap_container__HDCwv","markerImg":"SimpleMap_markerImg__fk+76"};